import axios from "axios";
import env from "../env";

const api_url = env.API_URL;

export const createInstructor = async (token: string, instructorData: any) => {
    try {
        const response = await axios.post(`${api_url}admin/create-instructor`, instructorData, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const updateInstructor = async (token: string, instructorData: any) => {
    try {
        const response = await axios.post(`${api_url}admin/update-instructor`, instructorData, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getStudents = async (token: string) => {
    try {
        const response = await axios.get(`${api_url}admin/get-users`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const updateStudent = async (token: string, studentData: any) => {
    try {
        const response = await axios.put(`${api_url}admin/update-user`, studentData, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const deleteStudent = async (token: string, studentId: string) => {
    try {
        const response = await axios.delete(`${api_url}admin/delete-user?Id=${studentId}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const banUnbanStudent = async (token: string, studentId: string, ban: any) => {
    try {
        const response = await axios.post(`${api_url}admin/ban-unban-user`, { id: studentId, status: ban }, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const createInstitutionUpdate = async (token: string, institutionData: any) => {
    try {
        const response = await axios.post(`${api_url}institution-updates`, institutionData, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const getInstitutionUpdates = async (token: string) => {
    try {
        const response = await axios.get(`${api_url}institution-updates`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const deleteInstitutionUpdate = async (token: string, Id: string, userId: string, userType: string) => {
    try {
        const response = await axios.delete(`${api_url}institution-updates/${Id}?userId=${userId}&userType=${userType}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const getInstitutionUpdateById = async (token: string, Id: string) => {
    try {
        const response = await axios.get(`${api_url}institution-updates/${Id}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const updateInstitutionUpdate = async (token: string, institutionData: any) => {
    try {
        const response = await axios.put(`${api_url}institution-updates`, institutionData, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const createPaymentPlan = async (token: string, paymentPlanData: any) => {
    try {
        const response = await axios.post(`${api_url}admin/payments`, paymentPlanData, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const getPaymentPlanByUserId = async (token: string, userId: string) => {
    try {
        const response = await axios.get(`${api_url}admin/payments/user/${userId}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const pay = async (token: string,id:any, paymentData: any) => {
    try {
        const response = await axios.put(`${api_url}admin/payments/${id}/pay`, paymentData, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const getStats = async (token: string) => {
    try {
        const response = await axios.get(`${api_url}admin/dashboard`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const getTopSPG = async (token: string) => {
    try {
        const response = await axios.get(`${api_url}admin/dashboard/high-spg`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const extendDueDate = async (token: string, userId: string, additionalWeeks: string) => {
    try {
        const response = await axios.put(`${api_url}admin/payments/update-expiration/${userId}?additionalWeeks=${additionalWeeks}`, { userId, additionalWeeks }, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}